export const isBool = val => typeof val === 'boolean';
